import traceActionsCreator from "../traceActionsCreator";

export const changeThemeMode = "theme/changeThemeMode";
export const changeThemeModeAction = traceActionsCreator(changeThemeMode);
